import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AppConstants from '../../AppConstants';
import newLogo from '../../StaticAssets/Images/g2wNewLogo.svg';
import './HeaderContainer.css';
import MainMenuComponent from './MainMenuComponent';
import ProfileMenuComponent from './ProfileMenuComponent';

export class HeaderContainer extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    isBig: PropTypes.bool.isRequired,
    title: PropTypes.string
  };

  render() {
    const { isBig, title } = this.props;
    const { t } = this.context;
    return (
      <div className={'headerContainer'}>
        <span className={'topHeader'}>
          <img id="gotowebinar_logo" src={newLogo} alt={`${AppConstants.APP_NAME} ${AppConstants.APP_VERSION}`} />
          <div />
        </span>
        <div>
          <div className="subHeader">
            <div className="mainMenu">
              <MainMenuComponent isBig={isBig} />
            </div>
            <h2 id="header_page_title">{title ? title : t('header.analytics')}</h2>
            <div className="profileMenu">
              <ProfileMenuComponent isBig={isBig} forceRefreshHack={t('header.analytics')} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default HeaderContainer;



// WEBPACK FOOTER //
// ./src/Application/Header/HeaderContainer.js